import React, { lazy } from 'react'
import { useParams } from 'react-router-dom'
import { FlyoutCloudSettingsWrapper as FlyOutAwsCloudSettings } from './FlyoutCloudSettingsWrapper'
import { useStyles } from './FlyoutCloudSettingsWrapper.styles'
import {
  EmptyState,
  SupportTicketButton,
} from '../../common/components/EmptyState/EmptyState'
import Disable from '../../common/images/Disable.png'

const FlyoutMicrosoftCloudSettings = lazy(() =>
  import(
    '../FlyOutOnboardingWrapper/FlyOutMicrosoftCloudSettings/FlyOutMicrosoftCloudSettings'
  ).then(module => ({
    default: module.FlyOutMicrosoftCloudSettings,
  }))
)

export const FlyOutCloudSettingsUmbrellaWrapper: React.FC = () => {
  const { classes } = useStyles()
  const { cloudType, accountId } = useParams<{
    cloudType: string
    accountId: string
  }>()
  if (cloudType === 'aws') {
    return <FlyOutAwsCloudSettings accountId={accountId} />
  }
  if (cloudType === 'azure') {
    return (
      <div className={classes.cloudAccountDetailWrapper}>
        <FlyoutMicrosoftCloudSettings accountId={accountId} />
      </div>
    )
  }
  return (
    <EmptyState
      imgSrc={Disable}
      header="Unsupported cloud provider"
      content={
        <div>
          <p>
            The selected cloud provider is not currently supported. We currently
            support AWS and Azure cloud platforms. Please contact support for
            assistance or select a supported cloud provider.
          </p>
        </div>
      }
      action={<SupportTicketButton />}
    />
  )
}

export default FlyOutCloudSettingsUmbrellaWrapper
